import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import StageHeader from './StageHeader';
import { ItemList } from './ItemList';

export const Column = React.memo(function Column({ column, index, handleAddStage, handleManageColumn, cardAction, disableDrag }) {
  return (
    <Draggable draggableId={column.id} index={index} isDragDisabled={disableDrag}>
      {(provided) => (
        <div className="column" {...provided.draggableProps} ref={provided.innerRef}>
          <StageHeader data={column} {...{ handleManageColumn, handleAddStage }} {...provided.dragHandleProps} />
          <ItemList column={column} index={index} cardAction={cardAction} />
        </div>
      )}
    </Draggable>
  );
});
